import { Loader2, Zap } from "lucide-react";
import { IMAGES } from "@/data/kits";
import { Reveal } from "@/components/Reveal";
import { useCheckout } from "@/lib/api";

export default function CTABand() {
  const { buy, loading } = useCheckout();
  return (
    <section className="relative">
      <div className="h-2 hazard-stripes" />
      <div className="relative overflow-hidden py-24 lg:py-32">
        <img
          src={IMAGES.lift}
          alt="Car on a hydraulic lift in a working repair shop"
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian via-obsidian/70 to-obsidian" />
        <Reveal className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-blaze font-semibold">Final call // Bay doors close at six</p>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.95] text-slate-50">
            Stop leaking money<br />on <span className="text-blaze">paperwork</span>
          </h2>
          <p className="mt-6 max-w-xl mx-auto text-sm sm:text-base text-slate-400 leading-relaxed">
            One bogus damage claim, one ghosted diagnostic, one month of SaaS fees — any of them costs
            more than the entire Complete Shop System. Bolt it on today.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <button
              data-testid="cta-band-button"
              onClick={() => buy("complete-shop-system")}
              disabled={loading !== null}
              className="inline-flex items-center gap-2.5 bg-blaze text-white font-display font-bold uppercase tracking-wide text-lg px-9 py-5 clip-notch-sm transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_0_35px_rgba(249,115,22,0.5)] disabled:opacity-60"
            >
              {loading === "complete-shop-system" ? <Loader2 className="w-5 h-5 animate-spin" /> : <Zap className="w-5 h-5" />}
              Get Complete — $297 once
            </button>
          </div>
          <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            14-day guarantee while files stay sealed // Instant download // Square secure checkout
          </p>
        </Reveal>
      </div>
      <div className="h-2 hazard-stripes" />
    </section>
  );
}
